module.exports = __webpack_public_path__ + "assets/62178254b83cdf243c0597f4b076dc2f.jpg";